module.exports = __webpack_public_path__ + "static/media/Version 2 Option 3 Screen B.b535599f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/smartinsure/Version 2 Option 3 Screen B.png
// module id = 631
// module chunks = 0